
<form class="form-wrapper" [formGroup]="filterForm" autocomplete=off>
  <!--
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.filter.suche' | translate }}</mat-label>
      <input
        matInput
        formControlName="suche"
        (input)="search()"
        placeholder="Projekt Eingeben"
        autocomplete=off
        class="suchFeld"
      />
    </mat-form-field>

    <mat-form-field class="datumFeld" appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.filter.start' | translate }}</mat-label>
      <input

        (ngModelChange)="search()"
        matInput
        [placeholder]="'pages.projektverwaltung.filter.start' | translate"
        [matDatepicker]="picker"
        formControlName="datumVon"
      />
      <mat-datepicker-toggle     [tabIndex]="-1" [disableRipple]="true" matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker  #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field class="datumFeld" appearance="outline" color="accent">
      <mat-label>{{ 'pages.projektverwaltung.filter.ende' | translate }}</mat-label>
      <input
        (ngModelChange)="search()"
        matInput
        [placeholder]="'pages.projektverwaltung.filter.ende' | translate"
        [matDatepicker]="endepicker"
        formControlName="datumBis"
      />
      <mat-datepicker-toggle     [tabIndex]="-1" matSuffix [for]="endepicker"></mat-datepicker-toggle>
      <mat-datepicker #endepicker></mat-datepicker>
    </mat-form-field>
  -->
  <mat-checkbox
    (change)="search($event.checked)"
    formControlName="archiv"
  >
    {{ 'pages.projektverwaltung.filter.archiv' | translate }}
  </mat-checkbox>
</form>

